{
    "VgU02k6x9GwMVJV2yztRq": {
        "position": {
            "x": 12,
            "y": 15,
            "z": 1
        },
        "key": "VgU02k6x9GwMVJV2yztRq",
        "tag": "spawn",
        "hasCollision": true
    },
    "-YOEPglxjh0V0juCE0A4o": {
        "position": {
            "x": 18,
            "y": 4,
            "z": 1
        },
        "key": "-YOEPglxjh0V0juCE0A4o",
        "tag": "spawn",
        "hasCollision": true
    },
    "sRv5Hjj6pffRh1PFZNqI6": {
        "position": {
            "x": 18,
            "y": 6,
            "z": 1
        },
        "key": "sRv5Hjj6pffRh1PFZNqI6",
        "tag": "spawn",
        "hasCollision": true
    },
    "KtAZcMHe4SmtBH2FDdBT9": {
        "position": {
            "x": 18,
            "y": 7,
            "z": 1
        },
        "key": "KtAZcMHe4SmtBH2FDdBT9",
        "tag": "spawn",
        "hasCollision": true
    },
    "nk_afzPxF4Zf6KOGI-rnl": {
        "position": {
            "x": 18,
            "y": 5,
            "z": 1
        },
        "key": "nk_afzPxF4Zf6KOGI-rnl",
        "tag": "spawn",
        "hasCollision": true
    },
    "v98X2gEopRC_mSKICpGS9": {
        "position": {
            "x": 18,
            "y": 8,
            "z": 1
        },
        "key": "v98X2gEopRC_mSKICpGS9",
        "tag": "spawn",
        "hasCollision": true
    },
    "ldJkCwHGNm3Kx2iLEL5QJ": {
        "position": {
            "x": 12,
            "y": 8,
            "z": 1
        },
        "key": "ldJkCwHGNm3Kx2iLEL5QJ",
        "tag": "spawn",
        "hasCollision": true
    },
    "baQZiFtK3Y6Y0CAD3jfjy": {
        "position": {
            "x": 12,
            "y": 7,
            "z": 1
        },
        "key": "baQZiFtK3Y6Y0CAD3jfjy",
        "tag": "spawn",
        "hasCollision": true
    },
    "i0PVjbCgtfzuvrUQz8xMY": {
        "position": {
            "x": 12,
            "y": 6,
            "z": 1
        },
        "key": "i0PVjbCgtfzuvrUQz8xMY",
        "tag": "spawn",
        "hasCollision": true
    },
    "jK9oj7cLWolpZEX7tpDNq": {
        "position": {
            "x": 12,
            "y": 5,
            "z": 1
        },
        "key": "jK9oj7cLWolpZEX7tpDNq",
        "tag": "spawn",
        "hasCollision": true
    },
    "33wuK_cxu4qhGGVu2bycD": {
        "position": {
            "x": 12,
            "y": 4,
            "z": 1
        },
        "key": "33wuK_cxu4qhGGVu2bycD",
        "tag": "spawn",
        "hasCollision": true
    },
    "fugcr6ff77j3AAPdgYQap": {
        "position": {
            "x": 18,
            "y": 21,
            "z": 1
        },
        "key": "fugcr6ff77j3AAPdgYQap",
        "tag": "spawn",
        "hasCollision": true
    },
    "2YNXDzRLPqpvNwbA9ALQ_": {
        "position": {
            "x": 18,
            "y": 20,
            "z": 1
        },
        "key": "2YNXDzRLPqpvNwbA9ALQ_",
        "tag": "spawn",
        "hasCollision": true
    },
    "ATj32TdkWSG77AlId7QBy": {
        "position": {
            "x": 18,
            "y": 19,
            "z": 1
        },
        "key": "ATj32TdkWSG77AlId7QBy",
        "tag": "spawn",
        "hasCollision": true
    },
    "htk_Gif9dgeHfmeE1EJld": {
        "position": {
            "x": 12,
            "y": 20,
            "z": 1
        },
        "key": "htk_Gif9dgeHfmeE1EJld",
        "tag": "spawn",
        "hasCollision": true
    },
    "I0KNxQvVGuuGCCqoJZmzv": {
        "position": {
            "x": 12,
            "y": 21,
            "z": 1
        },
        "key": "I0KNxQvVGuuGCCqoJZmzv",
        "tag": "spawn",
        "hasCollision": true
    },
    "xRKuIvSWLBBHrnrzwkYu8": {
        "position": {
            "x": 12,
            "y": 19,
            "z": 1
        },
        "key": "xRKuIvSWLBBHrnrzwkYu8",
        "tag": "spawn",
        "hasCollision": true
    },
    "p3vXpe-yvQTJIY0AHmVF5": {
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "p3vXpe-yvQTJIY0AHmVF5",
        "tag": "escape"
    },
    "TDciYx_C_lpMQ8z8VE1xO": {
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "TDciYx_C_lpMQ8z8VE1xO",
        "tag": "escape"
    },
    "BjxQ9cknHknsb9l8Aeeyh": {
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "BjxQ9cknHknsb9l8Aeeyh",
        "tag": "escape"
    },
    "lX6hz4EXzfa3Br7F4R-_O": {
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "lX6hz4EXzfa3Br7F4R-_O",
        "tag": "escape"
    },
    "VrKx9kWgIhXrX5Y2Mrc0m": {
        "position": {
            "x": 17,
            "y": 9,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "VrKx9kWgIhXrX5Y2Mrc0m",
        "tag": "escape"
    },
    "1KZG57BFEBxrOZ_8efsXt": {
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": -1
        },
        "key": "1KZG57BFEBxrOZ_8efsXt",
        "tag": "enter"
    },
    "FRUdI24qQ0KpDQWUqLuTR": {
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": -1
        },
        "key": "FRUdI24qQ0KpDQWUqLuTR",
        "tag": "enter"
    },
    "a4Log3TJDt8iJHD1O5C9g": {
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": -1
        },
        "key": "a4Log3TJDt8iJHD1O5C9g",
        "tag": "enter"
    },
    "W0nMtChjBTtF7NpSajR1D": {
        "position": {
            "x": 12,
            "y": 7,
            "z": 1
        },
        "key": "W0nMtChjBTtF7NpSajR1D",
        "tag": "spawn-tutorial",
        "hasCollision": true
    },
    "z6zL6ybpgFmCYdP8lCYaE": {
        "position": {
            "x": 18,
            "y": 8,
            "z": 1
        },
        "key": "z6zL6ybpgFmCYdP8lCYaE",
        "tag": "spawn-tutorial",
        "hasCollision": true
    },
    "IZNEKpvaVYqFX4ENyGg7H": {
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "key": "IZNEKpvaVYqFX4ENyGg7H",
        "tag": "spawn",
        "hasCollision": true
    },
    "ZL6GNQ92-NC1EBkb1daE5": {
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "key": "ZL6GNQ92-NC1EBkb1daE5",
        "tag": "spawn",
        "hasCollision": true
    },
    "YHwBvoJG9iEsGz3l1OSKE": {
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "key": "YHwBvoJG9iEsGz3l1OSKE",
        "tag": "spawn",
        "hasCollision": true
    },
    "Z45P3K-3sHAXnm0ErTzd_": {
        "position": {
            "x": 13,
            "y": 11,
            "z": 1
        },
        "key": "Z45P3K-3sHAXnm0ErTzd_",
        "tag": "spawn",
        "hasCollision": true
    },
    "tGTSVRxV76o9R4W5Wrjrr": {
        "position": {
            "x": 12,
            "y": 11,
            "z": 1
        },
        "key": "tGTSVRxV76o9R4W5Wrjrr",
        "tag": "spawn",
        "hasCollision": true
    },
    "38GtKG-5mz_Gix9LyVOD2": {
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "key": "38GtKG-5mz_Gix9LyVOD2",
        "tag": "spawn",
        "hasCollision": true
    },
    "xsZOkpxR1WH67KyRSYqwV": {
        "position": {
            "x": 17,
            "y": 22,
            "z": 1
        },
        "key": "xsZOkpxR1WH67KyRSYqwV",
        "tag": "spawn",
        "hasCollision": true
    },
    "fw_P_BWYtlNZdpb-pq-kP": {
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "key": "fw_P_BWYtlNZdpb-pq-kP",
        "tag": "spawn",
        "hasCollision": true
    },
    "3SvDIUC4zc_WH_WAuph4m": {
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "key": "3SvDIUC4zc_WH_WAuph4m",
        "tag": "spawn",
        "hasCollision": true
    },
    "iZAepLPr5JNrCI8kfYCAv": {
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "key": "iZAepLPr5JNrCI8kfYCAv",
        "tag": "spawn",
        "hasCollision": true
    },
    "5eextYB754WsW407Jk5Zg": {
        "position": {
            "x": 16,
            "y": 17,
            "z": 1
        },
        "key": "5eextYB754WsW407Jk5Zg",
        "tag": "spawn",
        "hasCollision": true
    },
    "VdBeTGu6MAbn_ICSWK8b3": {
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "key": "VdBeTGu6MAbn_ICSWK8b3",
        "tag": "spawn",
        "hasCollision": true
    },
    "lKBEyPZ7v6W2hXVtisRbT": {
        "position": {
            "x": 15,
            "y": 23,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "lKBEyPZ7v6W2hXVtisRbT",
        "tag": "escape"
    },
    "CT9Byc4tyiCmrS6gI3tIU": {
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "direction": {
            "x": -1,
            "y": 0
        },
        "key": "CT9Byc4tyiCmrS6gI3tIU",
        "tag": "enter"
    },
    "QZPOshJm22aafMCU0P02r": {
        "position": {
            "x": 12,
            "y": 13,
            "z": 1
        },
        "direction": {
            "x": -1,
            "y": 0
        },
        "key": "QZPOshJm22aafMCU0P02r",
        "tag": "enter"
    },
    "UJQ-Dam2dUa-j0jX6iyyT": {
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "direction": {
            "x": -1,
            "y": 0
        },
        "key": "UJQ-Dam2dUa-j0jX6iyyT",
        "tag": "enter"
    },
    "6qW0IL224I1UeuKnuzi-3": {
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "key": "6qW0IL224I1UeuKnuzi-3",
        "tag": "spawn",
        "hasCollision": true
    },
    "w4g7J_gOKB6pyeokI17bF": {
        "position": {
            "x": 11,
            "y": 13,
            "z": 1
        },
        "key": "w4g7J_gOKB6pyeokI17bF",
        "tag": "spawn",
        "hasCollision": true
    },
    "J5eYln_kYqxvqcMhVvGDj": {
        "position": {
            "x": 11,
            "y": 12,
            "z": 1
        },
        "key": "J5eYln_kYqxvqcMhVvGDj",
        "tag": "spawn",
        "hasCollision": true
    },
    "QBD-RRGM7M-LjXJCgPjsE": {
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "key": "QBD-RRGM7M-LjXJCgPjsE",
        "tag": "spawn",
        "hasCollision": true
    },
    "O9QQPYqwzuFtynmUG0bWe": {
        "position": {
            "x": 19,
            "y": 12,
            "z": 1
        },
        "direction": {
            "x": 1,
            "y": 0
        },
        "key": "O9QQPYqwzuFtynmUG0bWe",
        "tag": "escape"
    },
    "STDHlF0UXI2P9vmsd4ndX": {
        "position": {
            "x": 19,
            "y": 13,
            "z": 1
        },
        "direction": {
            "x": 1,
            "y": 0
        },
        "key": "STDHlF0UXI2P9vmsd4ndX",
        "tag": "escape"
    },
    "2DkaOuuknaLE2yODKBYxT": {
        "position": {
            "x": 19,
            "y": 14,
            "z": 1
        },
        "direction": {
            "x": 1,
            "y": 0
        },
        "key": "2DkaOuuknaLE2yODKBYxT",
        "tag": "escape"
    },
    "SIaNb": {
        "position": {
            "x": 13,
            "y": 3,
            "z": 1
        },
        "key": "SIaNb",
        "tag": "wall",
        "hasCollision": true
    },
    "atmpk": {
        "position": {
            "x": 14,
            "y": 3,
            "z": 1
        },
        "key": "atmpk",
        "tag": "wall",
        "hasCollision": true
    },
    "Qddy8": {
        "position": {
            "x": 15,
            "y": 3,
            "z": 1
        },
        "key": "Qddy8",
        "tag": "wall",
        "hasCollision": true
    },
    "jQzad": {
        "position": {
            "x": 16,
            "y": 3,
            "z": 1
        },
        "key": "jQzad",
        "tag": "wall",
        "hasCollision": true
    },
    "jgOwx": {
        "position": {
            "x": 17,
            "y": 3,
            "z": 1
        },
        "key": "jgOwx",
        "tag": "wall",
        "hasCollision": true
    },
    "Gjk2X": {
        "position": {
            "x": 17,
            "y": 11,
            "z": 1
        },
        "key": "Gjk2X",
        "tag": "wall",
        "hasCollision": true
    },
    "vESPz": {
        "position": {
            "x": 16,
            "y": 11,
            "z": 1
        },
        "key": "vESPz",
        "tag": "wall",
        "hasCollision": true
    },
    "QLjqe": {
        "position": {
            "x": 18,
            "y": 11,
            "z": 1
        },
        "key": "QLjqe",
        "tag": "wall",
        "hasCollision": true
    },
    "feXGs": {
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "key": "feXGs",
        "tag": "wall",
        "hasCollision": true
    },
    "IjDsj": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "key": "IjDsj",
        "tag": "wall",
        "hasCollision": true
    },
    "5wQ9i": {
        "position": {
            "x": 18,
            "y": 15,
            "z": 1
        },
        "key": "5wQ9i",
        "tag": "wall",
        "hasCollision": true
    },
    "l9lfa": {
        "position": {
            "x": 17,
            "y": 15,
            "z": 1
        },
        "key": "l9lfa",
        "tag": "wall",
        "hasCollision": true
    },
    "PYsXf": {
        "position": {
            "x": 14,
            "y": 23,
            "z": 1
        },
        "key": "PYsXf",
        "tag": "wall",
        "hasCollision": true
    },
    "o_XJE": {
        "position": {
            "x": 16,
            "y": 23,
            "z": 1
        },
        "key": "o_XJE",
        "tag": "wall",
        "hasCollision": true
    },
    "fGs-Y": {
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "key": "fGs-Y",
        "tag": "wall",
        "hasCollision": true
    },
    "465QO": {
        "position": {
            "x": 15,
            "y": 6,
            "z": 1
        },
        "key": "465QO",
        "tag": "wall",
        "hasCollision": true
    },
    "iMZ24": {
        "position": {
            "x": 15,
            "y": 7,
            "z": 1
        },
        "key": "iMZ24",
        "tag": "wall",
        "hasCollision": true
    }
}
